var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"demo-block"},[_c('h3',[_vm._v("基础用法")]),_c('el-x-conversations',{attrs:{"items":_vm.basicItems,"active":_vm.activeConversation},on:{"change":_vm.handleConversationChange}}),_c('div',{staticClass:"demo-description"},[_vm._v("默认模式下的会话列表，点击项目可以切换选中状态")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }